module.exports = __webpack_public_path__ + "static/media/palais.71d5b60b.jpg";